import React from "react";
import { Text, View } from "react-native";
import Collapsible from "react-native-collapsible";
import { Switch } from "react-native-gesture-handler";
import { t } from "react-native-tailwindcss";
import Card from "../atoms/Card";

const AccordionCard = ({
  children,
  checked,
  toggleSwitch,
  style,
  title,
}: {
  children?: React.ReactNode;
  checked: boolean;
  toggleSwitch: () => void;
  style: Record<string, string> | Record<string, string>[];
  title: string;
}): React.ReactElement => {
  return (
    <Card style={[t.p5, style]}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text style={styles.title}>{title}</Text>
        <Switch style={t.mB2} value={checked} onValueChange={toggleSwitch} />
      </View>
      <Collapsible collapsed={!checked} align="top">
        {children}
      </Collapsible>
    </Card>
  );
};

const styles = {
  bodyBackground: {
    overflow: "hidden",
  },
  title: [t.mB2, { fontWeight: "600" }],
};

export default AccordionCard;
